export const forBusiness_furniture_use = [
	{
		icon: '🛌',
		title: 'useData_title1',
		subtitle: 'useData_subtitle1',
	},
	{
		icon: '✨',
		title: 'useData_title2',
		subtitle: 'useData_subtitle2',
	},
	{
		icon: '🎨',
		title: 'useData_title3',
		subtitle: 'useData_subtitle3',
	},
	{
		icon: '🖼',
		title: 'useData_title4',
		subtitle: 'useData_subtitle4',
	},
	{
		icon: '🚀',
		title: 'useData_title5',
		subtitle: 'useData_subtitle5',
	},
];
